import axios from 'axios'

export const setLocation = (location) =>
  localStorage.setItem('location', JSON.stringify(location))

export const setCity = (city) =>
  localStorage.setItem('city', JSON.stringify(city))

export const setRegion = (region) =>
  localStorage.setItem('region', JSON.stringify(region))

export const getLocation = () =>
  JSON.parse(localStorage.getItem('location'))

export const getRegion = () =>
  JSON.parse(localStorage.getItem('region'))

export const getCity = () =>
  JSON.parse(localStorage.getItem('city'))

export const setLastLocationRequestTime = (LLRT) =>
  localStorage.setItem('lastLocationRequestTime', JSON.stringify(LLRT))

export const getLastLocationRequestTime = () =>
  JSON.parse(localStorage.getItem('lastLocationRequestTime'))

export const getLocationWatcher = () =>
  JSON.parse(localStorage.getItem('get_watcher'))

export const setLocationWatcher = (watcher) =>
  localStorage.setItem('geo_watcher', JSON.stringify(watcher))

export const getLocationCity = async () => {
  const location = getLocation()

  if (location) {
    const gMapKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY
    const latlng = `${location.latitude},${location.longitude}`
    const { data } = await axios.get(`https://maps.google.com/maps/api/geocode/json?key=${gMapKey}&latlng=${latlng}`)

    if (data.status === 'OK') {
      const address = data.results.find(r => r.types.includes('postal_code'))
      const city = address.address_components.find(c => c.types.includes('locality'))
      const zip = address.address_components.find(c => c.types.includes('postal_code'))
      return {
        city: city ? city.long_name : '',
        zip: zip ? zip.long_name : ''
      }
    }
  }

  return null
}



// WEBPACK FOOTER //
// ./src/routes/Home/helpers/location.js